import ApiService from '@/services/core/api.service'

const HistoryService = {
  async get (query = '') {
    return ApiService.get(`accounts-payable-accountant/reports/payment-postings?${query}`)
  },

  async post (payload) {
    return ApiService.post('accounts-payable-accountant/reports/payment-postings', payload)
  },

  async put (payload) {
    return ApiService.put(`accounts-payable-accountant/reports/payment-postings/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`accounts-payable-accountant/reports/payment-postings/${payload.id}`)
  }
}

export default HistoryService
